module.exports = __webpack_public_path__ + "static/media/ic_kappaletavarakuljetus_b.e5f181ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_kappaletavarakuljetus_b.svg
// module id = 1167
// module chunks = 0